<body
    class="flex items-center justify-center min-h-screen py-16 lg:py-10 bg-slate-50 dark:bg-zink-800 dark:text-zink-100 font-public">

    <div class="relative">
        <div class="absolute hidden opacity-50 ltr:-left-16 rtl:-right-16 -top-10 md:block">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125 316" width="125" height="316">
                <title>&lt;Group&gt;</title>
                <g id="&lt;Group&gt;">
                    <path id="&lt;Path&gt;" class="fill-custom-100/50 dark:fill-custom-950/50"
                        d="m23.4 221.8l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-100 dark:fill-custom-950"
                        d="m31.2 229.6l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-200/50 dark:fill-custom-900/50"
                        d="m39 237.4l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-200/75 dark:fill-custom-900/75"
                        d="m46.8 245.2l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-200 dark:fill-custom-900"
                        d="m54.6 253.1l-1.3-3.1v-315.4l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-300/50 dark:fill-custom-800/50"
                        d="m62.4 260.9l-1.2-3.1v-315.4l1.2 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-300/75 dark:fill-custom-800/75"
                        d="m70.3 268.7l-1.3-3.1v-315.4l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-300 dark:fill-custom-800"
                        d="m78.1 276.5l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-400/50 dark:fill-custom-700/50"
                        d="m85.9 284.3l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-400/75 dark:fill-custom-700/75"
                        d="m93.7 292.1l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-400 dark:fill-custom-700"
                        d="m101.5 299.9l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-500/50 dark:fill-custom-600/50"
                        d="m109.3 307.8l-1.3-3.1v-315.4l1.3 3.1z" />
                </g>
            </svg>
        </div>

        <div class="absolute hidden -rotate-180 opacity-50 ltr:-right-16 rtl:-left-16 -bottom-10 md:block">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125 316" width="125" height="316">
                <title>&lt;Group&gt;</title>
                <g id="&lt;Group&gt;">
                    <path id="&lt;Path&gt;" class="fill-custom-100/50 dark:fill-custom-950/50"
                        d="m23.4 221.8l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-100 dark:fill-custom-950"
                        d="m31.2 229.6l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-200/50 dark:fill-custom-900/50"
                        d="m39 237.4l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-200/75 dark:fill-custom-900/75"
                        d="m46.8 245.2l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-200 dark:fill-custom-900"
                        d="m54.6 253.1l-1.3-3.1v-315.4l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-300/50 dark:fill-custom-800/50"
                        d="m62.4 260.9l-1.2-3.1v-315.4l1.2 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-300/75 dark:fill-custom-800/75"
                        d="m70.3 268.7l-1.3-3.1v-315.4l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-300 dark:fill-custom-800"
                        d="m78.1 276.5l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-400/50 dark:fill-custom-700/50"
                        d="m85.9 284.3l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-400/75 dark:fill-custom-700/75"
                        d="m93.7 292.1l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-400 dark:fill-custom-700"
                        d="m101.5 299.9l-1.3-3.1v-315.3l1.3 3.1z" />
                    <path id="&lt;Path&gt;" class="fill-custom-500/50 dark:fill-custom-600/50"
                        d="m109.3 307.8l-1.3-3.1v-315.4l1.3 3.1z" />
                </g>
            </svg>
        </div>

        <div class="mb-0 w-screen lg:w-[500px] card shadow-lg border-none shadow-slate-100 relative">
            <div class="!px-10 !py-12 card-body">
                <a href="javascript:void(0);">
                    <img src="assets/images/totaldoc.png" alt="" class="hidden h-6 mx-auto dark:block"
                        style="width: 165px; height: 64px;">
                    <img src="assets/images/totaldoc.png" alt="" class="block h-6 mx-auto dark:hidden"
                        style="width: 165px; height: 64px;">
                </a>

                <div class="mt-8 text-center">
                    <h4 class="mb-1 text-custom-500 dark:text-custom-500">Recupera tu contraseña</h4>
                </div>

                <div *ngIf="!validEmail">
                    <form action="#!" class="mt-10" id="registerForm" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                        <div class="mb-3">
                            <label for="email-field" class="inline-block mb-2 text-base font-medium">Email</label>
                            <input type="text" id="email" formControlName="email"
                                class="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                placeholder="Introduzca su Correo Electrónico">
                            <div id="email-error" [class.hidden]="!(submitted && f['email'].errors)"
                                class="mt-1 text-sm text-red-500">Introduzca una dirección de correo electrónico válida.
                            </div>
                        </div>
                        <div class="mt-10">
                            <button type="submit"
                                class="w-full text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                Recuperar</button>
                        </div>
                    </form>

                    <div class="mt-10 text-center">
                        <p class="mb-0 text-slate-500 dark:text-zink-200"><a routerLink="/account-login" class="font-semibold underline transition-all duration-150 ease-linear text-slate-500 dark:text-zink-200 hover:text-custom-500 dark:hover:text-custom-500">Regresar</a> </p>
                    </div>
                </div>


                <div *ngIf="validEmail">
                    <form [formGroup]="resetForm" (ngSubmit)="onSubmitReset()">

                        <div class="mb-3 relative">
                            <label for="password-field" class="inline-block mb-2 text-base font-medium">Nueva
                                Contraseña</label>
                            <input [type]="fieldTextType ? 'text' : 'password'" id="password" formControlName="password"
                                class="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                placeholder="Introduzca su Contraseña">

                            <!-- Toggle Password Visibility Button -->
                            <button type="button" (click)="toggleFieldTextType()"
                                class="absolute inset-y-0 right-0 top-7 pr-3 flex items-center text-sm leading-5">
                                <svg [ngClass]="{'hidden': fieldTextType, 'block': !fieldTextType}"
                                    class="h-5 w-5 text-gray-500" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm7 0c0 3.866-4.029 7-9 7-1.655 0-3.204-.468-4.5-1.257m-2.18-3.79C4.264 15.312 3 13.76 3 12c0-3.866 4.029-7 9-7 1.34 0 2.613.26 3.751.732M3 3l18 18" />
                                </svg>
                                <svg [ngClass]="{'block': fieldTextType, 'hidden': !fieldTextType}"
                                    class="h-5 w-5 text-gray-500" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm4.5 0c0 3.866-4.029 7-9 7-1.655 0-3.204-.468-4.5-1.257M15 12a3 3 0 00-6 0M3 12c0 3.866 4.029 7 9 7 1.655 0 3.204-.468 4.5-1.257M19.5 12c0-3.866-4.029-7-9-7-.737 0-1.457.097-2.145.272" />
                                </svg>
                            </button>
                            <div *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.invalid"
                                class="text-red-500 text-sm mt-1">
                                <div *ngIf="resetForm.get('password')?.errors?.['required']">La contraseña es requerida.
                                </div>
                                <div *ngIf="resetForm.get('password')?.errors?.['minlength']">Mínimo 8 caracteres.</div>
                                <div *ngIf="resetForm.get('password')?.errors?.['passwordStrength']">
                                    Debe incluir mayúscula, minúscula, número y un símbolo.
                                </div>
                            </div>
                            <!-- <div id="paswsword-error" [class.hidden]="!(submitted && f['password'].errors)" class="mt-1 text-sm text-red-500">La contraseña debe tener al menos 8 caracteres y contener letras y números.</div> -->
                        </div>
                        <div class="mb-3">
                            <label for="passwordValidate-field"
                                class="inline-block mb-2 text-base font-medium">Confirmar Contraseña</label>
                            <input type="password" id="passwordValidate" formControlName="passwordValidate"
                                class="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                placeholder="Confirme su contraseña">
                        </div>

                        <!-- Mostrar mensaje de error si las contraseñas no coinciden -->
                        <div *ngIf="passwordsDoNotMatch()">
                            <p style="color: red;">Las contraseñas no coinciden</p>
                        </div>



                        <!-- Código OTP -->
                        <label for="passwordValidate-field" class="inline-block mb-2 text-base font-medium">Codigo de
                            Confirmación</label>

                        <div class="flex justify-center mb-6">
                            <ng-otp-input [ngClass]="{ 'wrong': wrongcode }" (onInputChange)="onOtpChange($event)"
                                [config]="{ length: 6 }"></ng-otp-input>
                        </div>

                        <!-- Botón -->
                        <div class="mt-10">
                            <button type="submit" [disabled]="resetForm.invalid"
                                class="w-full text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                Recuperar
                            </button>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    </div>


</body>